<template>
  <b-modal
    id="pacRush"
    ok-only
    no-close-on-backdrop
    :visible="true"
    ok-title="Accept"
    size="md"
    hide-footer
    body-class="text-center p-0"
    @hide="stopPendingGame"
    @close="stopPendingGame"
  >
    <template #modal-title>
      Pac Rush <feather-icon
        :icon="isMuted ? 'VolumeXIcon' : 'Volume2Icon' "
        size="20"
        role="button"
        @click="$emit('toggleSound')"
      />
    </template>
    <b-spinner
      v-if="isProcessing"
      type="grow"
      class="text-center"
      label="Loading..."
    />
    <iframe
      id="gameFrameContent"
      style="height: 80vh;width: 100%;"
      frameBorder="0"
    />
  </b-modal>

</template>
<script>
import { BModal, BSpinner } from 'bootstrap-vue'
// import { loadScript } from 'vue-plugin-load-script'

export default {
  components: {
    BModal,
    BSpinner,
  },
  props: {
    isMuted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProcessing: true,
    }
  },
  mounted() {
    const scripts = [
      '/pacrush/scripts/supportcheck.js',
      '/pacrush/scripts/offlineclient.js',
      '/pacrush/scripts/main.js',
      '/pacrush/scripts/register-sw.js',
    ]
    let html = ' <div id="gameContainer" />'
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < scripts.length; i++) {
      html += `<script src="${scripts[i]}"></`
      html += 'script>'
    }
    setTimeout(() => {
      const iframe = document.getElementById('gameFrameContent')
      iframe.contentWindow.document.open()
      iframe.contentWindow.document.write(html)
      iframe.contentWindow.document.close()
      iframe.contentWindow.document.addEventListener('pacRushGameOver', () => {
        this.$emit('gameOver')
      })
      this.isProcessing = false
    }, 1000)
  },
  methods: {
    getGameEndTime() {
      const startDate = this.gameStartAt
      // Do your operations
      const endDate = new Date()
      return (endDate.getTime() - startDate.getTime()) / 1000
    },
    stopPendingGame() {
      document.dispatchEvent(new Event('stopGameFromGec'))
      this.$emit('gameOver')
    },
  },
}
</script>
<style>
#pacRusher .modal-header .close {
  display:none;
}
</style>
